import PropTypes from "prop-types";
import { StoreCardAddress } from "./StoreCardAddress";
import { StoreCardTitle } from "./StoreCardTitle";
import { StoreCardHours } from "./StoreCardHours";
import { StoreCardMap } from "./StoreCardMap";
import { STOREPROPTYPES } from "./lib/constants";
import styles from "./styles/card.module.css";

export function StoreCard({ store, isIndex }) {
  const cardStyles = `${styles.wrapper} ${isIndex ? styles.index : ""}`;
  return (
    <div className={cardStyles}>
      <StoreCardTitle isIndex={isIndex} store={store} />
      <StoreCardAddress isIndex={isIndex} store={store} />
      <StoreCardHours isIndex={isIndex} store={store} />
      {!isIndex && <StoreCardMap store={store} />}
    </div>
  );
}

StoreCard.propTypes = {
  store: STOREPROPTYPES.isRequired,
  isIndex: PropTypes.bool,
};

StoreCard.defaultProps = {
  isIndex: false,
};
